<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Privacy Policy
      </content-page-title>
    </template>

    <div class="pa-2 white rounded-lg">
      <Privacy />
    </div>
  </ContentPage>
</template>


<script>
import { ContentPage, ContentPageTitle } from '@/components/pages'
import Privacy from '@/components/documents/Privacy_2025_08_28'

export default {
  name: 'PrivacyPolicy',

  components: { ContentPage, ContentPageTitle, Privacy },
}
</script>
